import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/close small.svg` */
export const CloseSmallIcon = createTripletGlyphIcon('CloseSmallIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0686 3.90291C11.2834 3.68812 11.6312 3.68812 11.846 3.90291C12.0606 4.11771 12.0607 4.46552 11.846 4.68026L8.6858 7.83944L12.0462 11.1998C12.2605 11.4145 12.2605 11.7624 12.0462 11.9771C11.8314 12.1917 11.4826 12.1917 11.2678 11.9771L7.90846 8.61776L4.7317 11.7945C4.51695 12.0091 4.16911 12.0091 3.95436 11.7945C3.73961 11.5798 3.73971 11.232 3.95436 11.0172L7.13111 7.84041L4.15358 4.86287C3.93889 4.64818 3.93907 4.30034 4.15358 4.08553C4.36836 3.87074 4.71613 3.87075 4.93092 4.08553L7.90846 7.06209L11.0686 3.90291Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6661 3.14901C13.9395 2.87576 14.383 2.87581 14.6564 3.14901C14.9297 3.42236 14.9296 3.86589 14.6564 4.13925L9.85754 8.93807L14.8068 13.8873C15.0798 14.1606 15.0798 14.6042 14.8068 14.8775C14.5335 15.1508 14.0899 15.1507 13.8165 14.8775L8.86731 9.92831L4.18372 14.6119C3.91037 14.8852 3.46685 14.8852 3.19348 14.6119C2.92025 14.3385 2.92016 13.895 3.19348 13.6217L7.87708 8.93807L3.34387 4.40487C3.07051 4.1315 3.07051 3.688 3.34387 3.41464C3.61726 3.14149 4.06081 3.14134 4.33411 3.41464L8.86731 7.94784L13.6661 3.14901Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.2928 4.22282C18.6442 3.87156 19.2138 3.87166 19.5653 4.22282C19.9165 4.57423 19.9174 5.14384 19.5662 5.49528L13.0955 11.965L19.7186 18.5871C20.0699 18.9385 20.0698 19.509 19.7186 19.8605C19.3671 20.2117 18.7965 20.2118 18.4451 19.8605L11.8221 13.2375L5.55451 19.506C5.20308 19.8573 4.63348 19.8573 4.28205 19.506C3.93092 19.1546 3.93085 18.585 4.28205 18.2336L10.5496 11.965L4.4344 5.8488C4.08329 5.49729 4.08402 4.92769 4.43537 4.57633C4.78676 4.22544 5.35551 4.22538 5.70686 4.57633L11.8231 10.6916L18.2928 4.22282Z"
        fill="currentColor"
      />
    </svg>
  ),
});
